import {
  isCampaignBusinessRuleMinActiveTradingDaysPerCampaignType,
  isCampaignBusinessRuleMinActiveTradingDaysPerMonthType,
} from './CampaignBusinessRule'
import { NameDto } from './NameDto'

export interface ClientContestCampaignDetailDto {
  id: string
  name: string | null
  type: NameDto
  calculationType: NameDto
  ranking: number
  points: number
  tradingAccount: ClientCampaignDetailTradingAccountDto
  disqualified: boolean
  disqualificationRule: CampaignBusinessRuleDto
}

interface ClientCampaignDetailTradingAccountDto {
  id: string
  name: string | null
  currencyId: string | null
  platformType: NameDto
}

interface CampaignBusinessRuleDto {
  businessRule: BusinessRuleDto
  businessRuleValue: number | null
}

export const isCampaignBusinessRuleMinActiveTradingDaysPerCampaign = (value?: NameDto) => {
  return isCampaignBusinessRuleMinActiveTradingDaysPerCampaignType(value?.id)
}

export const isCampaignBusinessRuleMinActiveTradingDaysPerMonth = (value?: NameDto) => {
  return isCampaignBusinessRuleMinActiveTradingDaysPerMonthType(value?.id)
}

interface BusinessRuleDto {
  id: number
  name: string | null
  businessRuleType: NameDto
  hasValue: boolean
}

export interface TradingDaysPerCampaignDto {
  minTradingDays?: number
  currentTradingDays?: number
  remainingTradingDays?: number
  businessRule?: NameDto
}

export interface DrawdownDto {
  maxDrawdownPercentage?: number
  maxDrawdown?: number
  currentDrawdownPercentage?: number
  currentDrawdown?: number
}
